import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faUserSlash } from '@fortawesome/pro-light-svg-icons'

import {
  Box, ListItem, StatusBadge, Text, UserProfileImage,
} from '@domain-group/suit-theme'

import type { ImageModel, TeamMemberModel, UserModel } from '@domain-group/realhub-backend-api-types'

import { getMemberRoleSetting } from '@functions/teamMember'

interface UserProps {
  image: ImageModel,
  itemCount: number,
  teamMember: TeamMemberModel,
  user: UserModel,
}

const User = (props: UserProps) => {
  const {
    image, itemCount, teamMember, user,
  } = props

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        as: 'a',
        borderBottom: '1px dashed',
        fontSize: 'small',
        paddingY: 'large',
      }}
      disableHover
      showAngleIcon={false}
    >
      <UserProfileImage
        boxProps={{ display: 'inline-flex' }}
        hintComponent={<UserProfileImage.Hint>{user.full_name || 'Unassigned'}</UserProfileImage.Hint>}
        imageUrl={image.thumb_url}
      >
        <FontAwesomeIcon icon={user.id ? faUser : faUserSlash} />
      </UserProfileImage>

      <Box alignItems="center" marginLeft="large" maxWidth="calc(100% - 46px)">
        <Box flexDirection="column" maxWidth="80%" paddingRight="large">
          <Text variant="ellipsis">{user.full_name}</Text>

          <Text
            color="bodyFontLightColor"
            display={['none', 'block']}
            fontSize="xsmall"
            marginTop="small"
            variant="ellipsis"
          >
            {/*
             // @ts-expect-error TS2345 */}
            {getMemberRoleSetting(teamMember.member_role, 'label')}
          </Text>
        </Box>

        {/*
         // @ts-expect-error TS17001 */}
        <Box maxWidth="40%" overflow="hidden" justifyContent="flex-end" overflow="visible">
          <Box marginLeft="auto" width="auto">
            <StatusBadge
              boxProps={{ borderRadius: 10, borderWidth: 2 }}
              color="#02b7e2"
              ghost
              text={`${itemCount}`}
              textProps={{ fontWeight: 'bold' }}
            />
          </Box>
        </Box>
      </Box>
    </ListItem>
  )
}

export default User
